import { render } from "./CheckboxField.vue?vue&type=template&id=2e3d8356"
import script from "./CheckboxField.vue?vue&type=script&lang=js"
export * from "./CheckboxField.vue?vue&type=script&lang=js"
script.render = render

export default script